import { useSyncExternalStore } from 'react';

export type ToastTone = 'success' | 'error' | 'warning' | 'info';

export interface ToastItem {
  id: number;
  tone: ToastTone;
  title: string;
  description?: string;
}

type Listener = () => void;

let items: ToastItem[] = [];
const listeners = new Set<Listener>();
let seq = 0;

function emit() {
  // Новый массив-ссылка для useSyncExternalStore.
  items = [...items];
  listeners.forEach((l) => {
    l();
  });
}

function remove(id: number) {
  items = items.filter((t) => t.id !== id);
  listeners.forEach((l) => {
    l();
  });
}

/** Success-тосты живут 3с, остальные — 7с (ТЗ §2.4 ToastDismissPolicy). */
export function pushToast(tone: ToastTone, title: string, description?: string): number {
  const id = ++seq;
  items = [...items, { id, tone, title, description }];
  emit();
  const ttl = tone === 'success' ? 3000 : 7000;
  setTimeout(() => {
    remove(id);
  }, ttl);
  return id;
}

export const toast = {
  success: (title: string, description?: string) => pushToast('success', title, description),
  error: (title: string, description?: string) => pushToast('error', title, description),
  warning: (title: string, description?: string) => pushToast('warning', title, description),
  info: (title: string, description?: string) => pushToast('info', title, description),
  dismiss: remove,
};

export function useToasts(): ToastItem[] {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => items,
    () => items,
  );
}
